function renderDate(date, lng){
	var options = {year: 'numeric', month: 'short', day: 'numeric' };
	var locale = (lng.startsWith("de")? "de-DE" : "en-US");
	return date.toLocaleDateString(locale, options);
}
export {renderDate};